/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { Close } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { updateAccount } from 'js/actions/userActions';
import { useForm } from 'react-hook-form';

export default function UserEditable(props) {
  const intl = useIntl();
  const { open, setOpen, user } = props;
  const dispatch = useDispatch();
  const { handleSubmit, register } = useForm();
  const [disable, setDisable] = useState(true);

  const handleChange = () => {
    setDisable(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = (user) => {
    dispatch(updateAccount(user)).then(() => {
      setOpen(false);
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ display: 'flex', justifyContent: 'space-between' }}
        id="alert-dialog-title"
      >
        <Chip
          label={intl.formatMessage({ id: 'app.myaccount.editUser.title' })}
          sx={{
            background: '#A53693',
            color: 'white',
          }}
        />
        <IconButton onClick={handleClose} title="Close">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid2 container={true} spacing={2}>
            <Grid2 size={{ lg: 6, md: 6, xs: 12 }}>
              <TextField
                margin="dense"
                onChange={handleChange}
                id="firstname"
                {...register('firstname')}
                name="firstname"
                defaultValue={user.personal_info.firstname}
                label={intl.formatMessage({
                  id: 'app.myaccount.editUser.firstNameLabel',
                })}
                type="text"
                fullWidth
              />
            </Grid2>
            <Grid2 size={{ lg: 6, md: 6, xs: 12 }}>
              <TextField
                margin="dense"
                onChange={handleChange}
                id="lastname"
                {...register('lastname')}
                name="lastname"
                defaultValue={user.personal_info.lastname}
                label={intl.formatMessage({
                  id: 'app.myaccount.editUser.lastNameLabel',
                })}
                type="text"
                fullWidth
              />
            </Grid2>
            <Grid2 size={{ lg: 6, md: 6, xs: 12 }}>
              <TextField
                margin="dense"
                onChange={handleChange}
                id="email"
                {...register('email')}
                name="email"
                label={intl.formatMessage({
                  id: 'app.myaccount.editUser.emailLabel',
                })}
                type="email"
                fullWidth
              />
            </Grid2>
            <Grid2 size={{ lg: 6, md: 6, xs: 12 }}>
              <TextField
                margin="dense"
                onChange={handleChange}
                id="password"
                {...register('password')}
                name="password"
                label={intl.formatMessage({
                  id: 'app.myaccount.editUser.newPasswordLabel',
                })}
                type="password"
                fullWidth
              />
            </Grid2>
            <Grid2 size={{ lg: 6, md: 6, xs: 12 }}>
              <TextField
                margin="dense"
                onChange={handleChange}
                defaultValue={user.personal_info.tel}
                id="tel"
                {...register('tel')}
                name="tel"
                label={intl.formatMessage({
                  id: 'app.myaccount.editUser.phoneNumbLabel',
                })}
                type="text"
                fullWidth
              />
            </Grid2>
            <Grid2 size={{ lg: 6, md: 6, xs: 12 }}>
              <TextField
                margin="dense"
                onChange={handleChange}
                defaultValue={user.personal_info.cel}
                id="cel"
                {...register('cel')}
                name="cel"
                label={intl.formatMessage({
                  id: 'app.myaccount.editUser.cellPhoneLabel',
                })}
                type="text"
                fullWidth
              />
            </Grid2>
          </Grid2>
          <Button
            variant="contained"
            color="secondary"
            fullWidth={true}
            size="large"
            sx={{ mt: 2 }}
            type="submit"
            disabled={disable}
          >
            {intl.formatMessage({
              id: 'app.myaccount.editUser.updateBtn',
            })}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
